const SERVER_ORIGIN = '/api' // use proxy only

export type TResponse<T> = {
    data: T | null,
    errors: string[],
    headers: Headers,
    status?: number
    details?: { existing_collection_id?: number, published_games_count?: number }
}

export function createApiUrl(path: string) {
    return `${SERVER_ORIGIN}${path}`
}

export default async function request<T>(path: string, params?: RequestInit) {
    const url = createApiUrl(path)
    const requestParams = params?.method ? {
        ...params,
        method: params.method.toUpperCase(),
    } : params

    return fetch(url, {
        headers: {
            'Content-type': 'application/json',
        },
        mode: 'cors',
        ...requestParams,
    }).then(async (resp):Promise<TResponse<T>> => {
        try {
            if (
                params?.method?.toLowerCase() !== 'head' && (
                    resp.headers.get('content-type') === 'application/json'
                    || resp.headers.get('content-type') === 'application/json; charset=utf-8'
                )
            ) {
                const body = await resp.json()
                if (resp.ok) {
                    return {
                        data: body,
                        errors: [],
                        headers: resp.headers,
                        status: resp.status,
                    }
                }
                return {
                    data: null,
                    errors: body.errors || [body.message],
                    headers: resp.headers,
                    status: resp.status,
                    ...(typeof body.existing_collection_id === 'number' || typeof body.published_games_count === 'number'
                        ? {
                            details: {
                                existing_collection_id: body.existing_collection_id,
                                published_games_count: body.published_games_count,
                            },
                        } : {}),
                }
            }
            if (resp.ok) {
                return {
                    data: await resp.text() as unknown as T, // should be a string
                    errors: [],
                    headers: resp.headers,
                    status: resp.status,
                }
            }
            return {
                data: null, // should be a string
                errors: [await resp.text()],
                headers: resp.headers,
                status: resp.status,
            }
        } catch (error) {
            const message = (error as Error).toString()
            return {
                data: null,
                errors: [message],
                headers: new Headers(),
                status: 0,
            }
        }
    })
}
